import React, { useState } from 'react';
import cn from 'classnames';
import { IEquipmentTypeOrAll } from '@ifit/gateway-wolf-dashboard-service';
import CardSkeleton from '@ifit/mp-card-skeleton';
import UserStats, { EquipmentTypeOption } from './user-stats';
import { formatDate } from '../../util/date-utils';
import { useUserStats } from '../../state-management/server-state/use-user-stats-v2';
import { getDefaultUserStats } from '../../data/default/user-stats';
import { useUserType } from '../../state-management/selectors/use-user-type';
import { Text } from './text';

export default function UserStatsSection(): JSX.Element {
  const before = formatDate(new Date(new Date().setDate(new Date().getDate() + 1)));

  const equipmentTypeOptions: EquipmentTypeOption[] = [
    { label: Text.allTypes, value: IEquipmentTypeOrAll.All },
    { label: Text.treadmill, value: IEquipmentTypeOrAll.Treadmill },
    { label: Text.bike, value: IEquipmentTypeOrAll.Bike },
    { label: Text.rower, value: IEquipmentTypeOrAll.Rower },
    { label: Text.elliptical, value: IEquipmentTypeOrAll.Elliptical },
    { label: Text.strength, value: IEquipmentTypeOrAll.Strength },
  ];
  const timeRanges = [
    {
      key: 'day',
      name: Text.day,
      before,
      after: formatDate(new Date()),
    },
    {
      key: 'week',
      name: Text.week,
      before,
      after: formatDate(new Date(new Date().setDate(new Date().getDate() - 7))),
    },
    {
      key: 'month',
      name: Text.month,
      before,
      after: formatDate(new Date(new Date().setMonth(new Date().getMonth() - 1))),
    },
    {
      key: 'year',
      name: Text.year,
      before,
      after: `${new Date().getFullYear()}-01-01`,
    },
  ];
  const [selectedTimeRange, setSelectedTimeRange] = useState(timeRanges[1]);
  const [selectedEquipmentType, setSelectedEquipmentType] = useState(equipmentTypeOptions[0].value) as [
    IEquipmentTypeOrAll,
    React.Dispatch<React.SetStateAction<IEquipmentTypeOrAll>>
  ];
  const { isFetching, isLoading, isIdle, error, data } = useUserStats(
    selectedTimeRange.before,
    selectedTimeRange.after,
    selectedEquipmentType
  );
  const isAnonymous = useUserType() === 'anonymous';
  const isLocked = isAnonymous;
  const stats = error || isLoading || isIdle || isAnonymous ? getDefaultUserStats(selectedEquipmentType) : data.stats;
  const skeleton = <CardSkeleton className="custom" />;
  const statsMarkup = (
    <UserStats
      equipmentTypeOptions={equipmentTypeOptions}
      loading={isFetching}
      locked={isLocked}
      selectedEquipmentType={selectedEquipmentType}
      selectedTimeRange={selectedTimeRange}
      stats={stats}
      timeRanges={timeRanges}
      updateEquipmentType={setSelectedEquipmentType}
      updateTimeRange={setSelectedTimeRange}
    />
  );
  const renderMarkup = isLoading ? skeleton : statsMarkup;

  return (
    <div
      className={cn('hero-stats', {
        loading: isLoading,
      })}
    >
      {renderMarkup}
    </div>
  );
}
